<template>
  <div>
    <vxe-grid
      ref="xTable"
      auto-resize
      border
      size="small"
      highlight-hover-row
      :data="tableData"
      :height="tableHeight"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      :edit-config="{enabled: !disabled, trigger: 'click', mode: 'row'}"
      :edit-rules="validRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-warning">
            <span class="side-frame-text">用箱需求</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="add"
              >添加需求
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="$refs.xTable.removeCheckboxRow()"
              >删除需求
            </b-button>
          </div>
        </slot>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    code: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableHeight: 360,
      formData: {},
      params: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      validRules: {
        boxType: [{required: true, message: '请选择箱型'}],
      },
    }
  },
  methods: {
    reset() {
      this.tableData = []
    },
    async getPackingData() {
      const $table = this.$refs.xTable
      // if ($table.getTableData().tableData < 1) {
      //   this.$message.error('订单用箱需求信息未填写，请检查')
      //   return
      // }
      const tableData = $table.getTableData().tableData
      let packingDataCheck = true
      tableData.forEach((item) => {
        if (
          item.boxType === null ||
          item.boxType === undefined ||
          item.boxType === ''
        ) {
          packingDataCheck = false
        }
      })
      if (!packingDataCheck) {
        this.$message({
          showClose: false,
          message: '用箱需求的箱型必须填写！',
          type: 'error',
        })
        return
      }
      return await tableData
    },
    async add() {
      const $table = this.$refs.xTable
      const {row: newRow} = await $table.insertAt({}, null)
      await $table.setActiveCell(newRow, 'boxType')
    },
  },
}
</script>
